/**
 * OData/REST lookup path segment after `/api/Lookup/` (backend contract; unchanged until API renames it).
 * Example: `/api/Lookup/hrm/AttendanceStatus`
 */
export const HRM_LOOKUP_API_SEGMENT = 'hrms' as const;
